import { isParagraph } from '@lumapps/wrex-typography/utils/isParagraph';

import { isText } from '../../../slate/utils/isText';
import type { Document } from '../../../types/core';

const isEmptyParagraph = (node: Document['children'][number]): boolean => {
    if (!isParagraph(node)) {
        return false;
    }
    if (node.children.length === 0) {
        return true;
    }
    if (node.children.length > 1) {
        return false;
    }
    return isText(node.children[0]) && node.children[0].text === '';
};

export const isRichTextContentEmpty = (richText: Document) => {
    const body = richText.children;

    if (!body || body.length === 0) {
        return true;
    }

    // A document containing only empty paragraphs (regardless of count) is considered empty
    return body.every(isEmptyParagraph);
};
